import { Form } from '@/features/settings/components/NotificationConfiguration/form/types'

export const getDefaultValues = (initialValues: Form): Form => {
    return {
        ...initialValues,
    }
}
